const BASENAME = process.env.PUBLIC_URL;

export const print = (gridRef, columnDefs, title, filtersStr, footer) => {
    const now = new Date();
    const dateString = now.toLocaleDateString() + ' ' + now.toLocaleTimeString();
    const rowData = [];
    gridRef.current.api.forEachNodeAfterFilterAndSort((node) => rowData.push(node.data));

    const tableHtml = `
        <table class="table-content">
            <thead>
                <tr>
                    ${columnDefs.map(col => `<th ${col.width ? `style='width:${col.width}'` : ""}>${col.headerName}</th>`).join('')}
                </tr>
            </thead>
            <tbody>
                ${rowData.map(row => `
                    <tr>
                        ${columnDefs.map(col => `<td>${row[col.field] ?? ""}</td>`).join('')}
                    </tr>`).join('')}
                
                ${footer ? footer : ""}
            </tbody>
        </table>
    `;

    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
        <html>
            <head>
                <title></title>
                <style>
                    @media print {
                        @page {
                            size: ledger landscape;
                            margin: 0mm 5mm !important;
                            -webkit-print-color-adjust: exact !important
                        }

                        header, footer {
                            position: fixed;
                            width: 100%;
                            left: 0;
                            text-align: center;
                            font-size: 12px;
                            color: #666;
                        }

                        header {
                            top: 0;
                            padding: 5px;
                            background-color: #f9f9f9;
                        }

                        footer {
                            bottom: 0;
                            padding: 5px;
                            background-color: #f9f9f9;
                        }

                        body {
                            font-family: Arial, sans-serif;
                            margin: 0;
                            display: flex;
                            flex-direction: column;
                        }

                        table.table-content {
                            width: 100%;
                            border-collapse: collapse;
                        }

                        .table-content thead {
                            display: table-header-group;
                        }

                        .table-content tr {
                            page-break-inside: avoid;
                        }

                        .table-content th, .table-content td {
                            border: 1px solid #ddd;
                            padding: 8px;
                            text-align: left;
                            word-wrap: break-word;
                        }

                        .table-content th {
                            background-color: #f2f2f2;
                        }
                        p, h2 { margin: 0}
                        
                        .print-header, .print-header-space {
                          height: 70px;
                        }
                        
                        .print-footer, .print-footer-space {
                          height: 40px;
                        }
                    }
                    
                    .mw-header {
                        width: 100%!important;
                        margin: 0!important;
                        max-height: 120px;
                        color: #000!important;
                        margin-bottom: -11px!important
                    }
                    
                    .mw-header-logo {
                        width: 150px
                    }
                    
                    .header-info {
                        width: calc(100vw - 150px);
                    }
                    
                    .mw-footer-logo {
                        float: left;
                        left: 0;
                        height: 8.5mm;
                        margin-top: 4px
                    }
                    
                    .mw-header-hr {
                        margin-top: 35px!important;
                        z-index: 1
                    }
                    
                    .mw-header-entity-name {
                        font-size: 4.5mm;
                        font-weight: 700;
                        text-align: center;
                        width: 100%;
                        margin-bottom: 0;
                        margin-block-start: 1mm;
                        line-height: 15px;
                    }
                    
                    .mw-header-entity-address {
                        text-align: center;
                        width: 100%;
                        font-weight: lighter;
                        z-index: 1;
                        font-size: 12px;
                        margin-top: 5px
                    }
                    
                    .mw-footer {
                        padding-top: 5px;
                        border-top: 1px solid #e7e7e7;
                        width: 100% !important;
                        margin: 0;
                        color: #000 !important;
                        padding-left: 0;
                        padding-right: 0;
                    }
                    
                    .mw-report-name {
                        position: absolute;
                        margin-top: 40px;
                        width: 100%;
                        text-transform: uppercase;
                        text-align: center;
                    }
                    
                    .mw-header-entity-city{
                        position: absolute;
                        margin-top: 17mm;
                        width: 100%;
                        text-transform: uppercase;
                        text-align: center;
                        font-size: 3mm;
                    }
                    
                    .print-header {
                      position: fixed;
                      top: 0mm;
                      width: 100%;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    }
                </style>
            </head>
            <body>
                <header>
                    <div class="print-header">
                        <div class="mw-header-logo">
                            <img src="${BASENAME}/img/logo-azul-semfundo.png" />
                        </div>
                        <div class="header-info">
                            <p class="mw-header-entity-name"> ${title}</p>
                            <p class="mw-header-entity-address">${filtersStr}</p>
                        </div>
                    </div>
                </header>
                <footer>
                    <div class="row mw-footer">
                        <p>MultiWay Comércio e Representações Ltda</p>
                        <p>Av. João Furtado Gouveia Sobrinho, 300, Itatiba, SP, CEP 13.251-534</p>
                        <p> ${dateString} - (11) 3183 5566 www.sentry.com.br</p>
                    </div>
                </footer>
                
                <table>
                    <thead>
                        <tr><td>
                            <div class="print-header-space"></div>
                        </td></tr>
                    </thead>
                    <tbody>
                        <tr><td>
                            <div class="print-content">
                                ${tableHtml}
                            </div>
                        </td></tr>
                    </tbody>
                    <tfoot>
                        <tr><td>
                            <div class="print-footer-space"></div>
                        </td></tr>
                    </tfoot>
                </table>
            </body>
        </html>
    `);

    setTimeout(() => {
        printWindow.document.close();
        printWindow.print();
        // printWindow.close();
    }, 100)
}